import React, { Component } from 'react';
import RestClientParamRow from './RestClientParamRow';

export default class RestClientParamsTab extends Component {
  render() {
    const { projectDetail } = this.props;
    return (
      <div className="row pt-2">
        <div className="col-md-4 col-lg-4">Key</div>
        <div className="col-md-8 col-lg-8">Value</div>
        {this.props.params.map((row) => {
          return (
            <RestClientParamRow
              paramRow={row}
              key={row.id}
              createNewRow={this.props.createNewParamRow}
              externalapi={this.props.externalapi}
              bodyDataFrom={this.props.bodyDataFrom}
              collectionName={this.props.collectionName}
              home={this.props.home}
              projectDetail={projectDetail}
            />
          );
        })}
      </div>
    );
  }
}
